export default "__VITE_ASSET__D_GzLFCY__"